/* global AppSettings */
/**
 * URL generation for static map
 *
 * @author  Tamara Bazko
 * */
import $ from 'jquery';
import Singleton from 'components/utils/Singleton';
import createLogger from 'components/logger/Logger';
import 'jquery.extendPrototype';
const Logger = createLogger('StaticMapManager');
function StaticMapManager() {
  Logger.info('Created');

  const apiProvider = AppSettings.country.toLowerCase() === 'cn' ? 'sogou' : 'google';

  const loaders = {
    sogouLoader: () => {
      return import(
        /* webpackChunkName: "import--sogouStaticMap" */ 'components/staticMap/API/sogouStaticMap'
      );
    },
    googleLoader: () => {
      return import(
        /* webpackChunkName: "import--googleStaticMap" */ 'components/staticMap/API/googleStaticMap'
      );
    },
  };

  loaders[`${apiProvider}Loader`].call().then(_ => {
    const MapRef = _.default;
    this.Map = MapRef;
    this.loadMap();
  });
}

$.extendPrototype(StaticMapManager, {
  Map: undefined,
  settings: {
    mapHeight: 505,
    mapSelector: '.js-storeDetails-map',
  },

  /**
   * Load map
   */
  loadMap() {
    this.Map.loadMap(this.settings.mapSelector, this.settings.mapHeight);
  },
});

export default Singleton.create(StaticMapManager, 'StaticMapManager');
